module.exports = __webpack_public_path__ + "img/shape_hearth--blue.d934712.webp";